import { decodeAuthToken } from "../components/utils";
import { useAuthStore } from "../store";

const operationalControlOperatorDomains = [
  "@rulezero.com",
  "@hissa.com",
  "@qarea.biz",
];

export function isOperationalControlOperatorEmail(email?: string): boolean {
  return Boolean(
    email &&
      operationalControlOperatorDomains.some((domain) =>
        email.toLowerCase().endsWith(domain)
      )
  );
}

export function useIsRulezeroUser(): boolean {
  const { accessToken, user } = useAuthStore();
  if (!accessToken) return false;
  try {
    const email = user?.emailId || decodeAuthToken(accessToken).emailId || "";
    return isOperationalControlOperatorEmail(email);
  } catch {
    return false;
  }
}
